import React, { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Filter, Header } from "./component";
import { Tab, Nav } from "react-bootstrap";
import { TotalTabs } from "./component/ACDtabs";
import {
  getACDMonthlyTotalReport,
  fetchConfigurations,
  exportMonthlyACDReport,
} from "actions";
import { isEmpty } from "lodash";

const MonthlyACD = () => {
  const [activeKey, setActiveKey] = useState("all");
  const location = useLocation();
  const dispatch = useDispatch();

  const { direction } = useSelector((state) => state.configurationState.lists);
  const session = useSelector((s) => s.session);
  const object_viewed_id = session?.current_page_permissions?.object_id || "";

  // Helper to format dates for the API
  const formatDateForAPI = (date) =>
    new Date(date).toLocaleString("sv-SE").replace("T", " ");

  // Initialize start and end periods for the last 12 months
  const getInitialDates = () => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setFullYear(startDate.getFullYear() - 1);
    return {
      start_period: formatDateForAPI(startDate),
      end_period: formatDateForAPI(endDate),
    };
  };

  const [extraFiltersState, setExtraFiltersState] = useState({
    values: {
      program_id: [],
      ...getInitialDates(),
    },
  });

  useEffect(() => {
    if (object_viewed_id) {
      dispatch(
        fetchConfigurations("direction, geography, business, language", {
          object_viewed_id,
        }),
      );
    }
  }, [dispatch, object_viewed_id]);

  const tabTitles = useMemo(() => {
    const titles = { all: "All" };
    if (direction) {
      direction.forEach((dir) => {
        titles[dir.id] = dir.value;
      });
    }
    return titles;
  }, [direction]);

  const currentTitle = tabTitles[activeKey] || "";

  const handleMonthlyACDReportFilter = () => {
    // Guard: Do not dispatch if object_viewed_id is not ready
    if (!object_viewed_id) {
      return;
    }
    const direction_ids = activeKey === "all" ? ["all"] : [activeKey];
    dispatch(
      getACDMonthlyTotalReport({
        ...extraFiltersState.values,
        object_viewed_id,
        direction_ids,
      }),
    );
  };

  const handleFilter = () => {
    handleMonthlyACDReportFilter();
  };

  useEffect(() => {
    // This effect now correctly waits for object_viewed_id
    handleFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey, object_viewed_id]);

  const handleExport = () => {
    if (!object_viewed_id) {
      return;
    }
    dispatch(
      exportMonthlyACDReport({ ...extraFiltersState.values, object_viewed_id }),
    );
  };

  return (
    <div className="wrapper-div">
      <Header
        onFilter={handleFilter}
        handleExport={handleExport}
        extraFiltersState={extraFiltersState}
        setExtraFiltersState={setExtraFiltersState}
      />
      <Filter
        onFilter={handleFilter}
        extraFiltersState={extraFiltersState}
        setExtraFiltersState={setExtraFiltersState}
      />
      <div className="p-3">
        <div className="view-container">
          <Tab.Container
            activeKey={activeKey}
            onSelect={(k) => setActiveKey(k)}
          >
            {/* Top Nav Tabs */}
            <h4 className="font-16 font-weight-medium m-0 pt-3 px-3">
              {currentTitle}
            </h4>
            <div className="d-flex justify-content-between align-items-center p-3">
              <Nav
                variant="tabs"
                activeKey={activeKey}
                onSelect={(k) => setActiveKey(k)}
              >
                <Nav.Item>
                  <Nav.Link eventKey="all">All</Nav.Link>
                </Nav.Item>
                {!isEmpty(direction) &&
                  direction.map((dir) => (
                    <Nav.Item key={dir.id}>
                      <Nav.Link eventKey={dir.id}>{dir.value}</Nav.Link>
                    </Nav.Item>
                  ))}
              </Nav>
            </div>

            {/* Tab Content */}
            <div>
              <Tab.Content>
                <Tab.Pane eventKey="all">
                  <TotalTabs
                    direction_id="all"
                    extraFiltersState={extraFiltersState}
                  />
                </Tab.Pane>
                {!isEmpty(direction) &&
                  direction.map((dir) => (
                    <Tab.Pane key={dir.id} eventKey={dir.id}>
                      <TotalTabs
                        direction_id={dir.id}
                        extraFiltersState={extraFiltersState}
                      />
                    </Tab.Pane>
                  ))}
              </Tab.Content>
            </div>
          </Tab.Container>
        </div>
      </div>
    </div>
  );
};

export default MonthlyACD;
